module.exports = __webpack_public_path__ + "static/img/testimony (65).f84e9cf4.jpg";